export default __webpack_public_path__ + "static/media/7.5c76f459.png";